// asset imports
import "@/assets/scss/dashboard.scss";

export default {};
